import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@mui/material"
import {ExpandMore as ExpandMoreIcon, LocationOn as LocationIcon} from "@mui/icons-material"
import React from "react"

import {CustomerAddressChangedActivityPayload, CustomerAddressChangedByCustomerActivityPayload} from "@indebted/api"

function AddressChangedActivity(
	panelId: number,
	{
		Title,
		HappenedAt,
		Payload,
	}: {
		Title: string
		HappenedAt: string
		Payload: CustomerAddressChangedActivityPayload | CustomerAddressChangedByCustomerActivityPayload
	},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string; activityContent: string; activityContentLabel: string; activityContentValue: string},
) {
	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<LocationIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{expanded && (
					<div className={classes.activityContent}>
						<div>
							<Typography className={classes.activityContentLabel}>NewAddress:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.NewAddress}</Typography>
						</div>
						{"AgentEmail" in Payload && (
							<div>
								<Typography className={classes.activityContentLabel}>Agent Email:</Typography>
								<Typography className={classes.activityContentValue}>{Payload.AgentEmail}</Typography>
							</div>
						)}
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

export {AddressChangedActivity}
